export default {
      id: "i-love-usage",
      viewBox: "0 0 39 39",
      url: __webpack_public_path__ + "img/sprite.svg#i-love",
      toString: function () {
        return this.url;
      }
    }